import { EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseModel } from '../models/basemodel';

export class CustomAction<T extends BaseModel> {
  protected _text: string;

  public primaryAction = false;

  public isDelete = false;

  public loading = false;

  public btnClass = 'btn-outline-secondary';

  public checkActive?: (id: string) => boolean;

  // Emits the id of the corresponding item
  action: EventEmitter<string>;

  constructor(text: string, primaryAction = false, isDelete = false, checkActive?: (id: string) => boolean) {
    this._text = text;
    this.action = new EventEmitter<string>();
    this.primaryAction = primaryAction;
    this.isDelete = isDelete;
    this.checkActive = checkActive;
  }

  // Argument is not used in this class, but it enabled other customActions to
  // determine the text based on the item or the items state
  getText(_?: T): string {
    return this._text;
  }

  // Argument is not used in this class, but it enabled other customActions to
  // determine the text based on the item or the items state
  isEnabled(_: T): Observable<boolean> {
    return of(true);
  }

  // Argument is not used in this class, but it enabled other customActions to
  // determine the class based on the item or the items state
  getClass(_?: T): string {
    return this.btnClass;
  }

  subscribe(fn: (id: string) => void): void {
    this.action.subscribe(fn);
  }

  emit(id: string): void {
    this.action.emit(id);
  }
}
